import { baseSchema, Update } from './base'
import { generate } from './generate'
import { z } from 'zod'

export const eventTypes = z.enum([
  'repo-create',
  'repo-commit',
  'repo-delete',
  'repo-rename',
  'repo-transfer',
  'repo-transfer-failed',
])

export type EventTypes = z.infer<typeof eventTypes>

const eventBase = baseSchema.extend({
  userId: z.string(),
  createdAt: z.string(),
  teamId: z.string(),
})

const event = z.discriminatedUnion('type', [
  z.object({
    type: z.literal('repo-rename'),
    oldRepoName: z.string(),
    newRepoName: z.string(),
    repoId: z.string(),
  }),
  z.object({
    type: z.literal('repo-create'),
    repoId: z.string(),
    repoName: z.string(),
  }),
  z.object({
    type: z.literal('repo-delete'),
    repoId: z.string(),
    repoName: z.string(),
  }),
  z.object({
    type: z.literal('repo-commit'),
    repoId: z.string(),
    repoName: z.string(),
  }),
  z.object({
    type: z.literal('repo-transfer'),
    repoId: z.string(),
    repoName: z.string(),
    teamName: z.string(),
    teamSlug: z.string(),
  }),
  z.object({
    type: z.literal('repo-fork'),
    repoId: z.string(),
    repoName: z.string(),
    sourceTeamName: z.string(),
    sourceTeamSlug: z.string(),
  }),
  z.object({
    type: z.literal('repo-transfer-failed'),
    repoId: z.string(),
    repoName: z.string(),
    teamName: z.string(),
    teamSlug: z.string(),
    error: z.string(),
  }),
])

export const eventSchema = eventBase.and(event)

export type ActivityEvent = z.infer<typeof eventSchema>
export type ActivityEventUpdate = Update<ActivityEvent>

export const eventBaseOps = generate('event', eventSchema.parse)
